import React, { useContext, useEffect } from "react";
import { Form } from "antd";
import { FormContainer } from "../../../";
import {
  EditProfileContext
} from "../../../../../contexts/shared/edit-profile";
import { CoursesInput } from "./courses-input";

export function CoursesForm({ editable = true, form }) {
  const { data } = useContext(EditProfileContext);

  useEffect(() => {
    const { courses = [] } = data?.user?.expertProfile?.professionalExperience ?? {};
    if (courses.length) {
      form.setFieldsValue({ courses });
    }
  }, [data]);

  return (
    <FormContainer>
      <Form form={form}>
        <Form.Item
          name="courses">
          <CoursesInput
            editable={editable} />
        </Form.Item>
      </Form>
    </FormContainer>
  );
}
